export function isBadPerfScore(team1, team2) {
  let isBadData = false;
  for (const team of [team1, team2]) {
    let count = 0;
    team.forEach((player) => {
      const avgScore = Math.round(((player.hardCarry || 0) + (player.teamplay || 0)) / 2);
      if (avgScore > 120) {
        count++;
      }
    });

    if (count >= 2) {
      isBadData = true;
    }
  }
  return isBadData;
}

export function getProfileUrl(path, regionId, summonerName, pathEnd) {
  return `${path}${regionId.toLowerCase()}/${encodeQuestionMark(summonerName).toLowerCase()}/${pathEnd}`;
}

export function encodeQuestionMark(summonerName) {
  return encodeURIComponent(summonerName);
}

export function decodeSummonerName(summonerName) {
  return decodeURIComponent(summonerName);
}
